import { takeEvery, call, put } from 'redux-saga/effects';
import { GET_HALL_CATEGORY, SET_HALL_CATEGORY } from '../actions';
import { appId, apiUrlV2 } from "../components/Helpers/Config";
import Axios from 'axios';

export const watchGetHallCategory = function* () {
  yield takeEvery(GET_HALL_CATEGORY, workerGetHallCategory);
}

function* workerGetHallCategory() {
  try {
    const uri = apiUrlV2+'catering/categories?app_id='+appId+"&cat_venue_type=hall&cat_product_val=no";
    const result = yield call(Axios.get, uri);
	var resultArr = [];
	resultArr.push(result.data);
    yield put({ type: SET_HALL_CATEGORY, value: resultArr });
  } 
  catch {
    console.log('Get Category Failed');
  }
}
